import { useGetReportByDepartment } from '../services/api';
import { ReportsTableSimple } from './ReportsTableSimple';

export const DepartmentReportsTable: React.FC<{ departmentId: number }> = ({ departmentId }) => {
  const { data, error, isLoading } = useGetReportByDepartment({ departmentId });
  return <ReportsTableSimple data={data} isLoading={isLoading} error={error} />;
};
